import { defineMessages } from 'react-intl';

export const NotificationMessages = defineMessages({
  notificationsTitle: {
    id: 'header.notifications.title',
    defaultMessage: 'Notifications',
  },
  readAllNotifications: {
    id: 'header.notifications.readAll',
    defaultMessage: 'Mark all as read',
  },
  showAllNotifications: {
    id: 'header.notifications.showAll',
    defaultMessage: 'Show all notifications',
  },
  noNewNotifications: {
    id: 'header.notifications.noNew',
    defaultMessage: 'No new notifications.',
  },
  allNotifications: {
    id: 'header.notifications.all',
    defaultMessage: 'All',
  },
  unreadNotifications: {
    id: 'header.notifications.unread',
    defaultMessage: 'Unread',
  },
  userAssignedAsContributorToEstimation: {
    id: 'header.notifications.user.assignedAsContributorToEstimation',
    defaultMessage: 'You have been assigned as a contributor to estimation ({projectName}).',
  },
  userAssignedAsPhaseLead: {
    id: 'header.notifications.user.assignedAsPhaseLead',
    defaultMessage: 'You have been assigned as a phase lead to estimation item ({projectName}).',
  },
  userAssignedAsPlanningResponsibleToEstimation: {
    id: 'header.notifications.user.assignedAsPlanningResponsibleToEstimation',
    defaultMessage:
      'You have been assigned as a planning responsible to estimation ({projectName}).',
  },
  userAssignedAsReviewerToEstimation: {
    id: 'header.notifications.user.assignedAsReviewerToEstimation',
    defaultMessage: 'You have been assigned as a reviewer to estimation ({projectName}).',
  },
  reviewRequested: {
    id: 'header.notifications.review.requested',
    defaultMessage: 'Review requested on estimation item ({projectName}).',
  },
  reviewApproved: {
    id: 'header.notifications.review.approved',
    defaultMessage: 'Estimation item approved ({projectName}).',
  },
  reviewCancelled: {
    id: 'header.notifications.review.cancelled',
    defaultMessage: 'Estimation review cancelled ({projectName}).',
  },
  commentAddedToEstimationItem: {
    id: 'header.notifications.comment.addedToEstimationItem',
    defaultMessage: 'A comment has been added to estimation item ({projectName}).',
  },
  estimationNewVersionCreated: {
    id: 'header.notifications.estimation.newVersion',
    defaultMessage: 'New version of estimation was created ({projectName}).',
  },
  estimationAiReviewCreated: {
    id: 'header.notifications.estimation.aiReview',
    defaultMessage: 'AI review has been created for estimation ({projectName}).',
  },
  reviewCommentsSummaryAvailable: {
    id: 'header.notifications.reviewCommentsSummary.available',
    defaultMessage: 'Review comments summary is available for estimation ({projectName}).',
  },
  estimationReviewOutcomeCompleted: {
    id: 'header.notifications.review.outcomeCompleted',
    defaultMessage: 'The estimation review you own has been completed ({projectName}).',
  },
  estimationReviewOutcomeCanceled: {
    id: 'header.notifications.review.outcomeCanceled',
    defaultMessage: 'The estimation review you own has been canceled ({projectName}).',
  },
  phaseStatusChanged: {
    id: 'header.notifications.phase.statusChanged',
    defaultMessage: 'The status of a phase has changed ({projectName}).',
  },
  phaseBlocked: {
    id: 'header.notifications.phase.blocked',
    defaultMessage: 'A phase has been blocked ({projectName}).',
  },
  phaseUnblocked: {
    id: 'header.notifications.phase.unblocked',
    defaultMessage: 'A phase has been unblocked ({projectName}).',
  },
  itemAssignedToPhase: {
    id: 'header.notifications.phase.itemAssigned',
    defaultMessage: 'An item has been assigned to a phase ({projectName}).',
  },
  phaseDeadlineApproaching: {
    id: 'header.notifications.phase.deadlineApproaching',
    defaultMessage: 'A phase deadline is approaching ({projectName}).',
  },
  conversationShared: {
    id: 'header.notifications.conversation.shared',
    defaultMessage: 'An AI Advisory conversation has been shared with you.',
  },
  deletedProject: {
    id: 'header.notifications.deletedProject',
    defaultMessage: 'deleted',
  },
  newNotificationsCount: {
    id: 'header.notifications.newCount',
    defaultMessage: '{count} New',
  },
  markAsRead: {
    id: 'header.notifications.markAsRead',
    defaultMessage: 'Mark as read',
  },
});
